import { render, staticRenderFns } from "./AuthModalRegister.vue?vue&type=template&id=4fb7174c&scoped=true&"
import script from "./AuthModalRegister.vue?vue&type=script&lang=js&"
export * from "./AuthModalRegister.vue?vue&type=script&lang=js&"
import style0 from "./AuthModalRegister.vue?vue&type=style&index=0&id=4fb7174c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb7174c",
  null
  
)

export default component.exports